import styled from 'styled-components'
import Typewriter from 'typewriter-effect';

function ACategory() {
  return (
   <Wrapper>
    <h3> <Typewriter
     options={{
    strings: [`'A' CATEGORY SCHOOL`],
    autoStart: true,
    loop: true,
  }}
/></h3>
    <div className='box_container'>
        <div className="box1">
           <p className='para1'>Consistently producing top results making us Certified as <span>‘A’</span> Category School on the basis of CBSE Board Results.</p> 
        </div>
        <div className='box2'>
           <p className='para2'>School has a different take on learning as it believes children could learn when they do it with their own hands, called as touch and feel education.</p>
        </div>
    </div>
   </Wrapper>
  )
}
const Wrapper = styled.section`
  h3{
    text-align:center;
    font-size:5rem;
  }
  .box_container{
    display: flex;
    justify-content: space-between;
    margin: 0 100px;
    gap: 50px;
  }
  .box1, .box2{ 
    p{
      text-align: justify;
      font-size: 2.5rem;
      line-height: 1.2;
      padding-bottom:5px;
    }
  }
  span{
    color:red;
  }
  img{
    width:100%;
    transition: all 250ms ease-in;
    &:hover{
      transform: scale(1.05);
      opacity: 0.8;
    }
  }

  @media (max-width: ${({ theme }) => theme.media.mobile}) {
    h3{
      font-size: 3.8rem;
    }
    .box_container{
      flex-direction: column;
      margin: 0 20px;
      gap: 20px;
    }
    .box1, .box2{ 
      p{
        text-align: justify;
        font-size: 2.5rem;
        line-height: 1.2;
      }
    }
    img{
      width:100%;
    }
  }
`;
export default ACategory